import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import BlogListItem2 from "../components/BlogListItem2";
import BlogListItem3 from "../components/BlogListItem3";
import Loading from "./Loading";
import PageHeader from "../components/PageHeader";
import BlogViewToggle from "../components/BlogViewToggle";

export default function SeriesItem() {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]); //blog
  const [seriesData, setSeriesData] = useState([]); //series
  const [parsedData, setParsedData] = useState(null);
  const [toggleViewState, setToggleViewState] = useState(0); //0 = list, 1 = grid
  const [headingsMap, setHeadingsMap] = useState({});

  const consoleMsg = `
  Client requested retrieval of series item
  Server queried blogs database with series filter
  `

  const streak = Math.floor((new Date() - new Date("2023-08-01")) / (1000 * 60 * 60 * 24)); //for daily cc

  //FETCH SERIES PAGE
  const fetchSeriesData = async ( id ) => {
    try {
      const response = await fetch(`https://imajin.dev/api/retrieve-a-page?id=${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const result = await response.json();
      // console.log("series", result);
      setSeriesData(result);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  //FETCH BLOGS
  const fetchData = async ( id ) => {    
    // console.log('sending', id);

    try {
      const response = await fetch(`https://imajin.dev/api/query-a-database-blogs-with-series`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ series_id: id })
      });
  
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const result = await response.json();

      console.log(result);
      
      setData(result);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  
  useEffect(() => {
    fetchSeriesData(id);
    fetchData(id);
  }, []);

  useEffect(() => {    
    setParsedData({
      name : seriesData.properties?.Name.title[0].plain_text,
      summary : seriesData.properties?.Summary.rich_text?.[0]?.plain_text,
      length : seriesData.properties?.Blogs?.relation?.length,
      thumbnail : seriesData.icon?.file.url,
    });
  }, [seriesData]);

  // Fetch block children for a blog and extract headings
  const fetchHeadings = async (blogId) => {
    try {
      const response = await fetch(`https://imajin.dev/api/retrieve-block-children?id=${blogId}`);
      if (!response.ok) throw new Error("Network response was not ok");
      const result = await response.json();
      // Filter for heading_1 and heading_2 blocks only
      const headings = (result.results || []).filter(
        (block) => block.type === "heading_1" || block.type === "heading_2"
      );
      return headings;
    } catch (error) {
      console.error("Error fetching headings for blog", blogId, error.message);
      return [];
    }
  };

  // Fetch all headings for blogs in data
  useEffect(() => {
    if (!data || data.length === 0) return;
    let cancelled = false;
    (async () => {
      const map = {};
      const promises = data.map(item => 
        fetchHeadings(item.id).then(headings => ({ id: item.id, headings }))
      );
      const results = await Promise.all(promises);
      results.forEach(({ id, headings }) => {
        map[id] = headings;
      });
      if (!cancelled) setHeadingsMap(map);
    })();
    return () => { cancelled = true; };
  }, [data]);

  useEffect(() => {
    setLoading(false);
  }, [data]);

return (
<>
{ loading ? <Loading/> :
<div className = "page">

  <PageHeader
    title={parsedData.name}
    date = { `${data.length > 0 ? data[data.length - 1]?.properties?.Date?.formula?.string : ""} · ${data.length} Posts` }
    description = { parsedData.summary }
    // color = "var(--ptB)"
  />

  <br/><br/>

  <BlogViewToggle value={toggleViewState === 1} onViewStateChange={setToggleViewState} />
  
  <br/><br/>

  {toggleViewState === 0 ? (
    data.map((item, index) => (
      <div key={index} style = { { padding : "0px 6vw"} }>
        <BlogListItem2 item={item} index={index} headings={headingsMap[item.id] || []} length={data.length} />
      </div>
    ))
  ) : (
    <div
    className = "seriesGrid"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "2px",
        marginTop: "32px"
      }}
    >
      {data.map((item, index) => {
        const bgColor = item.properties?.background?.rich_text?.[0]?.plain_text || "black";
        return (
          <BlogListItem3
            key={item.id}
            item={item}
            index={index}
            style={{
              background: bgColor,
              overflow: "hidden",
              position: "relative",
              minHeight: 0,
              ...(index === 0 ? { gridRow: "span 2" } : {}),
              gridColumn: index === 0 ? "1 / span 1" : undefined,
              display: "flex",
              alignItems: "stretch",
              justifyContent: "stretch"
            }}
          />
        );
      })}
    </div>
  )}
</div>
}
</>
);
}